"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MotorDeclineText = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var moment = require("moment");
var MotorDeclineText = /** @class */ (function () {
    function MotorDeclineText(props) {
        var _this = this;
        this.props = props;
        var interaction = this.props.interaction;
        var underwritingResult = interaction.underwritingResult[0];
        this.index = underwritingResult.objectReference && underwritingResult.objectReference.index ? underwritingResult.objectReference.index : 0;
        this.driver = interaction.policyHolder;
        if (underwritingResult.objectReference && underwritingResult.objectReference.objectName === "additionalDrivers" &&
            interaction.additionalDrivers && interaction.additionalDrivers.length !== 0 && interaction.additionalDrivers[this.index]) {
            this.driver = interaction.additionalDrivers[this.index];
        }
        var isPolicyHolder = false;
        if (underwritingResult.objectReference &&
            underwritingResult.objectReference.objectName &&
            underwritingResult.objectReference.objectName === "policyHolder") {
            isPolicyHolder = true;
        }
        var personalizedMessage = (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "We can't insure ", this.driver.firstName, ".", (0, jsx_runtime_1.jsx)("br", {}), "If you'd like to continue with your quote without ", this.driver.firstName, " included, please remove them."] });
        var defaultMessage = (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] });
        this.underwritingResultCustomerWordings = [
            {
                key: "UW001",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW002",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW003",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW004",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW005",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we don\u2019t insure this type of car."] })
            },
            {
                key: "UW006",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we don\u2019t insure this type of car."] })
            },
            {
                key: "UW007",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW008",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we don\u2019t insure this type of car."] })
            },
            {
                key: "UW010",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we don\u2019t insure this type of car."] })
            },
            {
                key: "UW011",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we don\u2019t insure this type of car."] })
            },
            {
                key: "UW013",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we don\u2019t insure this type of car."] })
            },
            {
                key: "UW016",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW019",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "We can't insure ", this.driver.firstName, " without their driving licence number"] })
            },
            {
                key: "UW020",
                value: isPolicyHolder ? defaultMessage : personalizedMessage
            },
            {
                key: "UW021",
                value: isPolicyHolder ? defaultMessage : personalizedMessage
            },
            {
                key: "UW023",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because of the driving licence you have."] })
            },
            {
                key: "UW024",
                value: isPolicyHolder ? defaultMessage : personalizedMessage
            },
            {
                key: "UW025",
                value: isPolicyHolder ? defaultMessage : personalizedMessage
            },
            {
                key: "UW028",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because of your age."] })
            },
            {
                key: "UW030",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we only insure a maximum of 6 drivers on 1 car."] })
            },
            {
                key: "UW031",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we only insure a maximum of 8 drivers on 1 account."] })
            },
            {
                key: "UW032",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because one of your drivers is not old enough for us to insure them on one of the cars you have selected."] })
            },
            {
                key: "UW033",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because of your driving history."] })
            },
            {
                key: "UW034",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because of your claims history."] })
            },
            {
                key: "UW035",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because of your claims history."] })
            },
            {
                key: "UW036",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because of your claims history."] })
            },
            {
                key: "UW037",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because of your claims history."] })
            },
            {
                key: "UW038",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because of your claims history."] })
            },
            {
                key: "UW039",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because of your claims history."] })
            },
            {
                key: "UW040",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because of your driving history."] })
            },
            {
                key: "UW041",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because of your driving history."] })
            },
            {
                key: "UW042",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because of your driving history."] })
            },
            {
                key: "UW043",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because of your driving history."] })
            },
            {
                key: "UW044",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because of your driving history."] })
            },
            {
                key: "UW045",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because of the driving history of you or your drivers."] })
            },
            {
                key: "UW046",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because of the driving history of you or your drivers."] })
            },
            {
                key: "UW47",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because of the driving history of you or your drivers."] })
            },
            {
                key: "UW048",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because of the driving history of you or your drivers."] })
            },
            {
                key: "UW049",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because of the driving history of you or your drivers."] })
            },
            {
                key: "UW050",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW052",
                value: isPolicyHolder ? defaultMessage : personalizedMessage
            },
            {
                key: "UW054",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW055",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW056",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW059",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW060",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW061",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW064",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW066",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW067",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry we can't insure you...", (0, jsx_runtime_1.jsx)("br", {}), "\"Based on some of the information you\u2019ve provided, we\u2019re unable to give you a quote.", (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), "We check the information you provide against a range of industry databases. If there\u2019s a mismatch in these details, we might not be able to provide you with a quote.\"", (0, jsx_runtime_1.jsx)("br", {}), "For example:", (0, jsx_runtime_1.jsx)("br", {}), "- Details of any previous claims made by drivers on the account. This includes the dates of any claims, whether the claim was fault or non-fault, regardless of whether the driver had a policy in their own name at the time.", (0, jsx_runtime_1.jsx)("br", {}), "- Use of the car. The registered keeper or main user and where the vehicle is kept may affect our ability to provide cover so it's important this is correctly recorded.", (0, jsx_runtime_1.jsx)("br", {}), "- The driving history for each driver. Driving history for each driver may affect our ability to provide cover."] })
            },
            {
                key: "UW068",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry we can't insure you...", (0, jsx_runtime_1.jsx)("br", {}), "\"Based on some of the information you\u2019ve provided, we\u2019re unable to give you a quote.", (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), "We check the information you provide against a range of industry databases. If there\u2019s a mismatch in these details, we might not be able to provide you with a quote.\"", (0, jsx_runtime_1.jsx)("br", {}), "For example:", (0, jsx_runtime_1.jsx)("br", {}), "- Details of any previous claims made by drivers on the account. This includes the dates of any claims, whether the claim was fault or non-fault, regardless of whether the driver had a policy in their own name at the time.", (0, jsx_runtime_1.jsx)("br", {}), "- Use of the car. The registered keeper or main user and where the vehicle is kept may affect our ability to provide cover so it's important this is correctly recorded.", (0, jsx_runtime_1.jsx)("br", {}), "- The driving history for each driver. Driving history for each driver may affect our ability to provide cover."] })
            },
            {
                key: "UW069",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry we can't insure you...", (0, jsx_runtime_1.jsx)("br", {}), "\"Based on some of the information you\u2019ve provided, we\u2019re unable to give you a quote.", (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), "We check the information you provide against a range of industry databases. If there\u2019s a mismatch in these details, we might not be able to provide you with a quote.\"", (0, jsx_runtime_1.jsx)("br", {}), "For example:", (0, jsx_runtime_1.jsx)("br", {}), "- Details of any previous claims made by drivers on the account. This includes the dates of any claims, whether the claim was fault or non-fault, regardless of whether the driver had a policy in their own name at the time.", (0, jsx_runtime_1.jsx)("br", {}), "- Use of the car. The registered keeper or main user and where the vehicle is kept may affect our ability to provide cover so it's important this is correctly recorded.", (0, jsx_runtime_1.jsx)("br", {}), "- The driving history for each driver. Driving history for each driver may affect our ability to provide cover."] })
            },
            {
                key: "UW070",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry we can't insure you...", (0, jsx_runtime_1.jsx)("br", {}), "\"Based on some of the information you\u2019ve provided, we\u2019re unable to give you a quote.", (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), "We check the information you provide against a range of industry databases. If there\u2019s a mismatch in these details, we might not be able to provide you with a quote.\"", (0, jsx_runtime_1.jsx)("br", {}), "For example:", (0, jsx_runtime_1.jsx)("br", {}), "- Details of any previous claims made by drivers on the account. This includes the dates of any claims, whether the claim was fault or non-fault, regardless of whether the driver had a policy in their own name at the time.", (0, jsx_runtime_1.jsx)("br", {}), "- Use of the car. The registered keeper or main user and where the vehicle is kept may affect our ability to provide cover so it's important this is correctly recorded.", (0, jsx_runtime_1.jsx)("br", {}), "- The driving history for each driver. Driving history for each driver may affect our ability to provide cover."] })
            },
            {
                key: "UW071",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry we can't insure you...", (0, jsx_runtime_1.jsx)("br", {}), "\"Based on some of the information you\u2019ve provided, we\u2019re unable to give you a quote.", (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), "We check the information you provide against a range of industry databases. If there\u2019s a mismatch in these details, we might not be able to provide you with a quote.\"", (0, jsx_runtime_1.jsx)("br", {}), "For example:", (0, jsx_runtime_1.jsx)("br", {}), "- Details of any previous claims made by drivers on the account. This includes the dates of any claims, whether the claim was fault or non-fault, regardless of whether the driver had a policy in their own name at the time.", (0, jsx_runtime_1.jsx)("br", {}), "- Use of the car. The registered keeper or main user and where the vehicle is kept may affect our ability to provide cover so it's important this is correctly recorded.", (0, jsx_runtime_1.jsx)("br", {}), "- The driving history for each driver. Driving history for each driver may affect our ability to provide cover."] })
            },
            {
                key: "UW072",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can\u2019t offer you a quote because of the number of modifications to the ", this.props.interaction.vehicles && this.props.interaction.vehicles[this.index] &&
                            this.props.interaction.vehicles[this.index].make, ", ", this.props.interaction.vehicles && this.props.interaction.vehicles[this.index] &&
                            this.props.interaction.vehicles[this.index].model, " (", this.props.interaction.vehicles && this.props.interaction.vehicles[this.index] &&
                            this.props.interaction.vehicles[this.index].registrationNumber, ")."] })
            },
            {
                key: "UW073",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW076",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW077",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW078",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry we can't insure you...", (0, jsx_runtime_1.jsx)("br", {}), "Based on some of the information you've provided, we're unable to give you a quote."] })
            },
            {
                key: "UW079",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you. This could be for a number of reasons, including your age or driving experience for the car you\u2019d like to insure."] })
            },
            {
                key: "UW080",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you. This could be for a number of reasons, including your age or driving experience for the car you\u2019d like to insure."] })
            },
            {
                key: "UW081",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry we can't insure you...", (0, jsx_runtime_1.jsx)("br", {}), "Based on some of the information you've provided, we're unable to give you a quote."] })
            },
            {
                key: "UW082",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry we can't insure you...", (0, jsx_runtime_1.jsx)("br", {}), "Based on some of the information you've provided, we're unable to give you a quote."] })
            },
            {
                key: "UW083",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you. This could be for a number of reasons, including your age or driving experience for the car you\u2019d like to insure."] })
            },
            {
                key: "UW084",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW085",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we only insure a maximum of 3 vehicles on 1 account.", (0, jsx_runtime_1.jsx)("br", {}), "If you'd like to continue with your quote please remove ", this.props.interaction.vehicles && this.props.interaction.factors.numberOfVehicles ?
                            this.props.interaction.vehicles.length + this.props.interaction.factors.numberOfVehicles - 3
                            : "some", " of the vehicles"] })
            },
            {
                key: "UW086",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we need ", this.driver.firstName, " to be assigned as a driver to at least one vehicle."] })
            },
            {
                key: "UW087",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote for the ", this.props.interaction.vehicles && this.props.interaction.vehicles[this.index] &&
                            this.props.interaction.vehicles[this.index].make, ", ", this.props.interaction.vehicles && this.props.interaction.vehicles[this.index] &&
                            this.props.interaction.vehicles[this.index].model, " (", this.props.interaction.vehicles && this.props.interaction.vehicles[this.index] &&
                            this.props.interaction.vehicles[this.index].registrationNumber, ") because of the relationship between you and the registered keeper of the car."] })
            },
            {
                key: "UW088",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we don\u2019t insure this type of car."] })
            },
            {
                key: "UW089",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), (function () {
                            if (_this.props.interaction.numberOfVehicles === 1) {
                                return ((0, jsx_runtime_1.jsxs)("p", { children: ["...we can't offer you a quote on ", _this.props.interaction.vehicles && _this.props.interaction.vehicles[_this.index] &&
                                            _this.props.interaction.vehicles[_this.index].make, ", ", _this.props.interaction.vehicles && _this.props.interaction.vehicles[_this.index] &&
                                            _this.props.interaction.vehicles[_this.index].model, " (", _this.props.interaction.vehicles && _this.props.interaction.vehicles[_this.index] &&
                                            _this.props.interaction.vehicles[_this.index].registrationNumber, ") because one of your drivers does not have enough driving experience for us to insure them on this type of car."] }));
                            }
                            else {
                                return ((0, jsx_runtime_1.jsx)("p", { children: "...we can't offer you a quote because one of your drivers does not have enough driving experience for us to insure them on one of the cars you have selected." }));
                            }
                        })()] })
            },
            {
                key: "UW090",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW093",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW094",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW095",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because we require a tracker to be fitted to the ", this.props.interaction.vehicles && this.props.interaction.vehicles[this.index] &&
                            this.props.interaction.vehicles[this.index].make, ", ", this.props.interaction.vehicles && this.props.interaction.vehicles[this.index] &&
                            this.props.interaction.vehicles[this.index].model, " (", this.props.interaction.vehicles && this.props.interaction.vehicles[this.index] &&
                            this.props.interaction.vehicles[this.index].registrationNumber, ")."] })
            },
            {
                key: "UW096",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we don\u2019t insure this type of car."] })
            },
            {
                key: "UW097",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW098",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we don\u2019t insure this type of car."] })
            },
            {
                key: "UW099",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because of the driving history of you or your drivers."] })
            },
            {
                key: "UW103",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW106",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...you can only add one temporary driver per subscription month."] })
            },
            {
                key: "UW107",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...you can only replace your car up to two times per subscription month."] })
            },
            {
                key: "UW108",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we don\u2019t insure this type of car under this offering.", (0, jsx_runtime_1.jsx)("br", {})] })
            },
            {
                key: "UW109",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry we can't insure you...", (0, jsx_runtime_1.jsx)("br", {}), "\"Based on some of the information you\u2019ve provided, we\u2019re unable to give you a quote.", (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), "We check the information you provide against a range of industry databases. If there\u2019s a mismatch in these details, we might not be able to provide you with a quote.\"", (0, jsx_runtime_1.jsx)("br", {}), "For example:", (0, jsx_runtime_1.jsx)("br", {}), "- Details of any previous claims made by drivers on the account. This includes the dates of any claims, whether the claim was fault or non-fault, regardless of whether the driver had a policy in their own name at the time.", (0, jsx_runtime_1.jsx)("br", {}), "- Use of the car. The registered keeper or main user and where the vehicle is kept may affect our ability to provide cover so it's important this is correctly recorded.", (0, jsx_runtime_1.jsx)("br", {}), "- The driving history for each driver. Driving history for each driver may affect our ability to provide cover."] })
            },
            {
                key: "UW110",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry we can't insure you...", (0, jsx_runtime_1.jsx)("br", {}), "\"Based on some of the information you\u2019ve provided, we\u2019re unable to give you a quote.", (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), "We check the information you provide against a range of industry databases. If there\u2019s a mismatch in these details, we might not be able to provide you with a quote.\"", (0, jsx_runtime_1.jsx)("br", {}), "For example:", (0, jsx_runtime_1.jsx)("br", {}), "- Details of any previous claims made by drivers on the account. This includes the dates of any claims, whether the claim was fault or non-fault, regardless of whether the driver had a policy in their own name at the time.", (0, jsx_runtime_1.jsx)("br", {}), "- Use of the car. The registered keeper or main user and where the vehicle is kept may affect our ability to provide cover so it's important this is correctly recorded.", (0, jsx_runtime_1.jsx)("br", {}), "- The driving history for each driver. Driving history for each driver may affect our ability to provide cover."] })
            },
            {
                key: "UW111",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW112",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW113",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW114",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW115",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UW116",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can\u2019t insure this driver."] })
            },
            {
                key: "UW121",
                value: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "you or any additional drivers have an unspent conviction and we can't insure you anymore"] }), (0, jsx_runtime_1.jsxs)("p", { children: ["We will cancel your cover in 7 days on ", moment().add(7, "days").endOf("day").format("D MMM YYYY, HH:mm")] })] }))
            },
            {
                key: "UW124",
                value: defaultMessage
            },
            {
                key: "UW125",
                value: defaultMessage
            },
            {
                key: "UW126",
                value: defaultMessage
            },
            {
                key: "UW127",
                value: defaultMessage
            },
            {
                key: "UW128",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...you can only add car up to two times per subscription month."] })
            },
            {
                key: "UW129",
                value: defaultMessage
            },
            {
                key: "UW130",
                value: defaultMessage
            }
        ];
    }
    ;
    return MotorDeclineText;
}());
exports.MotorDeclineText = MotorDeclineText;
//# sourceMappingURL=MotorDeclineText.js.map